import 'mdn-polyfills/NodeList.prototype.forEach';
import Swiper from 'swiper';
import { Navigation,Pagination } from 'swiper/modules';

export default class Slider {
  constructor(element) {
    this.element = element;
    this.swiperElement = this.element;

    this.settings = {
      modules: [Navigation, Pagination],
      navigation: {
        nextEl: '.js-slider-next',
        prevEl: '.js-slider-prev',
      },
      spaceBetween: 16,
      slidesPerView: 'auto',
      slidesPerGroupAuto: false,
      centeredSlides: true,
      breakpoints: {
        960: {
          spaceBetween: 113,
        },

        780: {
          spaceBetween: 40,
        },
      },


    };

    this.swiper;
  }


  mount() {
    this.settings = {
      ...this.settings,
    }

    this.swiper = new Swiper(this.swiperElement, this.settings);

    const pager = document.querySelector('.js-slider-pager');
    this.swiper.on('slideChange', () => {
    const activeIndex = this.swiper.realIndex;

    if (pager) {
      pager.innerHTML = activeIndex + 1;
    }
});
  }

  unmount() {
    this.destroy(this.swiper, true);
  }
}
